import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledMenu = styled.div`
  width: 100%;
  height: 100vh;
  background-color: white;
  position: fixed;
  top: 0px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a {
    text-decoration: none;
    color: #323333;
    display: block;
    margin-bottom: 6px;
    font-size: 16px;
    &:hover {
      text-decoration: none;
    }
  }
`;

const Menu = ({ toggleMenu, menuActive }) => (
  <StyledMenu className={`fab-menu ${menuActive ? "is-active" : ""}`}>
    <div>
      <Link onClick={toggleMenu} className="body" to="/">
        Home
      </Link>
    </div>
    <div>
      <Link onClick={toggleMenu} className="body" to="/about">
        About
      </Link>
    </div>
    <div>
      <Link onClick={toggleMenu} to="/projects" className="body">
        Gallery
      </Link>
    </div>
  </StyledMenu>
);

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.jsx